<template>
    <div class="pt-15 animated fadeIn staticPageInner equipmentList bgV2">
    	<div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <gofix-card fullContent>
                <gofix-table
                    :settings="tableConfig"
                    :table-items="tableItems"
                    @load-items="getTableData"
                    @row-click="clickToRowItem"
                    ref="gofixTable">
                    <template slot="gofix_table:created_by" slot-scope="row">
                        {{ row.item.import_by ? row.item.import_by.name : row.item.title.toLowerCase() == 'import dorj' ? 'Cron System' : '' }}
                    </template>
                    <template slot="gofix_table:created_at" slot-scope="row">
                        {{ row.item.created_at ? row.item.created_at : '' | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY") }}
                    </template>
                    <template slot="gofix_table:accepted_at" slot-scope="row">
                        {{ row.item.accepted_at ? row.item.accepted_at : '' | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY") }}
                    </template>
                    <template slot="gofix_table:data" slot-scope="row">
                        <div class="d-flex table-import-log-status" v-if="row.item.data && row.item.data.count">
                            <p class="mb-0 mr-2 d-flex align-items-center">
                                <span class="mr-2 icon-dot icon-dot-succeeded"></span>
                                <span>{{row.item.data.count.succeeded}} succeeded</span>
                            </p>
                            <p class="mb-0 mr-2 d-flex align-items-center">
                                <span class="mr-2 icon-dot icon-dot-warning"></span>
                                <span>{{row.item.data.count.warning}} warning</span>
                            </p>
                            <p class="mb-0 d-flex align-items-center">
                                <span class="mr-2 icon-dot icon-dot-failed"></span>
                                <span>{{row.item.data.count.failed}} failed</span>
                            </p>
                        </div>
                    </template>
                    <template slot="gofix_table:file_name" slot-scope="row">
                        <div @click.stop="clickToRowItem" v-if="checkIsJson(row.item.file_name)">
                            <json-viewer
                                :value="row.item.file_name | isJson"
                                :expand-depth="0"
                                sort>
                            </json-viewer>
                        </div>
                        <div v-else v-html="row.item.file_name"></div>
                    </template>
                    <template slot="gofix_table:number_of_records" slot-scope="row">
                        <div v-if="row.item.data && row.item.data.count">{{row.item.data.count.succeeded + row.item.data.count.failed}}</div>
                    </template>
                </gofix-table>
            </gofix-card>
            <b-modal :no-close-on-backdrop="true"
                modal-class="modal-create modal-import-logs"
                title="Detail Log"
                hide-footer :centered="true"
                v-model="modals.detail.open">
                <div class="importLogDetail" v-if="modals.detail.data">
                    <ul>
                        <li class="text-bold">
                            <span class="line">Line 1:</span>
                            <span class="desc">This is column name</span>
                        </li>
                        <li v-for="log in modals.detail.data.data.log" v-bind:class="{ warning: log.status === 'warning', failed: log.status === 'failed', succeeded: log.status === 'succeeded' }" class="d-flex">
                            <span class="line">Line {{log.line}}:</span>
                            <span class="desc" v-html="log.desc ? log.desc : ''"></span>
                        </li>
                    </ul>
                </div>
                <div class="pt-3 pb-3">
                    <b-button-group class="text-right d-block pr-3">
                        <gofix-button label="CLOSE" @click="modals.detail.open = false" noBorder dark></gofix-button>
                    </b-button-group>
                </div>
            </b-modal>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { filters } from '@/_filterVar.js'
    import JsonViewer from 'vue-json-viewer'
    export default {
        name: 'import-logs-lmu',
        components: { JsonViewer },
        data() {
            let filter = JSON.parse(JSON.stringify(filters['import_logs_lmu']));
            return {
                tableConfig:{
                    name: 'table-import-logs-lmu',
                    controls:{
                        create: false,
                        update: true,
                        delete: false,
                        tableImport: false,
                        tableExport: false,
                        tableColumnSettings: false,
                        reload: true,
                        tablePagination: true,
                        tableFilter: true
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    sortColumn: "id",
                    sortDirection: "asc",
                    fields: [
                    {
                            key: 'created_by',
                            label: 'Imported By',
                            isActive: 1,
                            isFilter: true,
                            sorting: true,
                            thClass: 'text-left',
                            tdClass: 'text-left',
                            thStyle: "width: 200px",
                        },
                        {
                            key: 'created_at',
                            label: 'Date and Time',
                            isActive: 1,
                            isFilter: true,
                            sorting: true,
                            thClass: 'text-left',
                            tdClass: 'text-left',
                            thStyle: "width: 200px",
                        },
                        {
                            key: 'file_name',
                            label: 'File Name',
                            isActive: 1,
                            isFilter: true,
                            sorting: true,
                            thClass: 'text-left',
                            tdClass: 'text-left',
                            thStyle: "width: 200px",
                        },
                        {
                            key: 'file_type',
                            label: 'File Type',
                            isActive: 1,
                            isFilter: true,
                            sorting: true,
                            thClass: 'text-left',
                            tdClass: 'text-left',
                            thStyle: "width: 150px",
                        },
                        {
                            key: 'number_of_records',
                            label: 'Number of Records',
                            isActive: 1,
                            isFilter: true,
                            sorting: true,
                            thClass: 'text-right',
                            tdClass: 'text-right',
                            thStyle: "width: 200px",
                        },
                        {
                            key: 'data',
                            label: 'Description',
                            isActive: 1,
                            isFilter: false,
                            sorting: false,
                            thClass: 'text-left',
                            tdClass: 'text-left',
                            thStyle: "width: 400px",
                        },
                        {
                            key: 'accepted_by',
                            label: 'Accepted By',
                            isActive: 1,
                            isFilter: true,
                            sorting: true,
                            thClass: 'text-left',
                            tdClass: 'text-left',
                            thStyle: "width: 200px",
                        },
                        {
                            key: 'accepted_at',
                            label: 'Accepted Date',
                            isActive: 1,
                            isFilter: true,
                            sorting: true,
                            thClass: 'text-left',
                            tdClass: 'text-left',
                            thStyle: "width: 200px",
                        },
                        {
                            key: 'auto',
                            label: '',
                            isActive: 1,
                            isFilter: false,
                            sorting: false,
                            thClass: 'text-center',
                            tdClass: 'text-center'
                        },
                    ]
                },
                tableItems: [],
                modals: {
                    detail: {
                        open: false,
                        loading: false,
                        data: null,
                    }
                }
            }
        },
        created() {
            
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID',
            }),
        },
        watch: {
            ClientContractID: function(val) {
                this.$refs.gofixTable.reloadTableItems();
            }
        },
        filters: {
            isJson(value) {
                try {
                    JSON.parse(value);
                } catch (e) {
                    return value;
                }
                return JSON.parse(value);
            }
        },
        methods: {
            async getTableData(callback) {
                const { tableRequest , resolve, reject } = await callback();
                
                await this.$store.dispatch("BatchSubmissionController/getImportLog", tableRequest)
                .then(response => {
                    this.tableItems = response.items;
                    this.tableConfig.total = response.total;
                    resolve(response);
                })
                .catch(err => { 
                    reject()
                })
            },
            clickToRowItem(item){
                this.modals.detail.open = true;
                this.modals.detail.data = item;
            },
            checkIsJson(item){
                if(!item) return false;
                try {
                    JSON.parse(item);
                } catch (e) {
                    return false;
                }
                return true;
            },
        }
    }
</script>